module.exports = "table {\n    font-size: 15px;\n}\n\ntable thead {\n    display: none;\n}\n\ntable .description td.colspan100{\n    padding: 0;\n}\ntable .description table{\n    margin: 0;\n    border: none;\n}\n\ntable .description table tbody tr {\n    border: none;\n}\n\ntable .description table tbody tr:not(last-child) {\n    border-bottom: 1px solid #edf0f4;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/contas/conta-contabil/conta-contabil-table/conta-contabil-table.component.css
 ** module id = 1027
 ** module chunks = 0
 **/